export default __webpack_public_path__ + "static/media/2.bb863649.png";